import gql from 'graphql-tag';

import STATUS_FRAGMENT from './STATUS_FRAGMENT';

const GET_SERVICE_RUN = gql`
	query($id: String) {
		getServiceRun(id: $id) {
			...serviceRunStatus
		}
	}
	${STATUS_FRAGMENT}
`;


export default GET_SERVICE_RUN;

